import {useEffect, useState} from "react";
import {getOrder, userOrders} from "../api/apis";
import {useNavigate, useParams} from "react-router";
import { useApp } from "../Context";

export default function ProfilePage() {
    const [orderids, setOrderids] = useState([]);
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const size = 5;
    const navigate = useNavigate();
    const {restaurant} = useParams();
    const {auth} = useApp()
    
    // Only run this when auth is confirmed
    useEffect(() => {
        if (auth) {
            const loadOrderIds = async () => {
                const stored = JSON.parse(localStorage.getItem("orderids")) || {};
                const restStored = stored[restaurant] ?? []
                const fetched = await fetchOrderIds(auth.phone, auth.code);
                const combined = [...new Set([...restStored, ...fetched].map(Number))]
                    .sort((a, b) => b - a);

                setOrderids(combined);
                setOrders(Array(combined.length).fill(null));
            };
    
            loadOrderIds();
        }
    }, [auth]);
    

    const fetchOrderIds = async (phone, code) => {
        if(phone && code){
            const res = await userOrders(phone, code)
            if(res.ok){
                return res.orders
            }
        }

        return []
    }

    const fetchOrders = async () => {
        const top = size * page;
        const bottom = size * (page - 1);

        setLoading(true);
        try {
            for (let i = bottom; i < orderids.length && i < top; i++) {
                if (orders[i] !== null) continue; // Skip already fetched
                const id = orderids[i];
                const result = await getOrder(id);
                setOrders(prev => {
                    const updated = [...prev];
                    updated[i] = result;
                    return updated;
                });
            }
        } catch (error) {
            console.error("Error fetching orders", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrders();
    }, [orderids, page]);

    function OrderItem({order, index}) {
        const id = orderids[index];

        if (order === null) {
            return (
                <div key={index} className="border-bottom border-muted d-flex align-items-center justify-content-between">
                    <p className="mb-0 p-2 fw-bold text-muted">#{parseInt(id)}</p>
                    <div className="spinner-border text-warning mx-4"></div>
                </div>
            );
        }

        if (!order.order || Object.keys(order.order).length === 0) {
            return (
                <div key={index} className="border-bottom border-muted d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center justify-content-between">
                        <i className="bi bi-exclamation-diamond text-danger fs-5"></i>
                        <p className="mb-0 p-2 fw-bold text-muted">#{parseInt(id)}</p>
                    </div>
                        <p className="mb-0 p-2 text-danger fw-semibold mx-3">Ordern hittades inte</p>
                </div>
            );
        }

        const {datum, orderid, belopp, paid} = order.order.order00;

        return (
            <div key={index} className="border-bottom border-muted d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    {paid === "1" ? (
                        <i className="bi bi-check-circle text-success fs-5"></i>
                    ) : (
                        <i className="bi bi-exclamation-triangle text-warning fs-5"></i>
                    )}
                    <p className="mb-0 p-2 fw-bold text-muted">#{parseInt(orderid)}</p>
                    <p className="mb-0 p-2">{`${datum.slice(0, 4)}-${datum.slice(4, 6)}-${datum.slice(6, 8)}`}</p>
                </div>
                <div className="d-flex gap-1">
                    <p className="mb-0 p-2 fw-bold">{(belopp / 100).toFixed(2)} SEK</p>
                    <span style={{marginLeft: "auto"}} onClick={() => navigate(`/${restaurant}/order/${orderid}`)}>
                        <i className="bi bi-arrow-right-short fs-2"></i>
                    </span>
                </div>
            </div>
        );
    }

    function PageSwitcher() {
        const pageCount = Math.ceil(orderids.length / size);
        if (pageCount <= 1) return null;

        return (
            <div className="d-flex justify-content-center mt-2">
                {Array.from({length: pageCount}).map((_, i) => (
                    <button
                        key={i}
                        onClick={() => setPage(i + 1)}
                        className={`btn btn-sm me-1 ${page === i + 1 ? "btn-secondary" : "btn-outline-secondary"}`}
                    >
                        {i + 1}
                    </button>
                ))}
            </div>
        );
    }

    const bottom = size * (page - 1);
    const top = size * page;

    return (
        <div className="mt-5 px-1">
            <div className="fs-5 fw-semibold d-flex align-items-center" onClick={()=>navigate("../order")}>
                <i className="bi bi-arrow-left-short fs-1 fw-bold"></i>
                <p className="mb-0">Tillbaka</p>
            </div>
            <div className="px-2">
                <p className="mt-1 text-muted fs-5 fw-semibold mb-0">Tidigare beställningar</p>
                <div className="card border-0 shadow-sm p-2 mt-1">
                    {orderids.length > 0 ? (
                        orderids
                            .slice(bottom, top)
                            .map((_, index) => (
                                <OrderItem order={orders[bottom + index]} index={bottom + index} key={bottom + index}/>
                            ))
                    ) : (
                        <div className="text-center text-muted">Inga tidigare beställningar</div>
                    )}
                    <PageSwitcher/>
                </div>
                {/* 
                <button
                    onClick={() => {
                        const items = ["0000000002", "0000000008", "0000000012", "0000000017", "0000000135", "0000000020", "0000000021", "00000007124", "0000000028", "0000000032", "0000000036", "0000000044", "0000000047", "0000000048"];
                        localStorage.setItem("orderids", JSON.stringify(items.reverse()));
                        window.location.reload(); // force re-mount
                    }}
                    className="btn btn-sm btn-outline-primary mt-3"
                >
                    Load test orders
                </button>
                */}
            </div>
        </div>
    );
}
